import React from 'react'
import { Modal } from 'pcln-modal'
import { Box } from 'pcln-design-system'
import StyledHeading from '@/components/StyledHeading'
import useExpressDealModal from '@/hooks/useExpressDealModal'
import { ANALYTICS_CATEGORY_FLIGHTS } from '@/constants/analytics'
import CONTENT from '@/constants/content'
import { FLIGHT_TYPE_INFO, ROUND_TRIP, ONE_WAY } from '../constants'
import { onSubmitExpressDeal } from '../SearchForm/utils'
import Form from '../SearchForm/Form'

/**
 * TODO: Add fallback in StyleHeading, please refer
 * commit history for fallback text
 */

export default function ExpressDealModal({
  isModalOpen,
  gaCategory = ANALYTICS_CATEGORY_FLIGHTS,
  qsKey = 'modal',
  qsValue = 'express-deals'
}: {
  isModalOpen: boolean
  gaCategory?: string
  qsKey?: string
  qsValue?: string
}) {
  const { closeModal } = useExpressDealModal(qsKey, qsValue)
  return (
    <Modal
      isOpen={isModalOpen}
      onClose={closeModal}
      width={[1, 750]}
      enableOverflow
      timeout={50}
    >
      <Box p={[3, 0]}>
        <Box px={[0, 3]}>
          <StyledHeading
            text={CONTENT.homepage.flights.expressDeals.headline}
            fontSize={[3, null, null, 5]}
            lineHeight="display"
            tag="h1"
          />
          <StyledHeading
            text={CONTENT.homepage.flights.expressDeals.subHeadline}
            fontSize={[1, null, null, 4]}
            mb={3}
            lineHeight="display"
            tag="h2"
          />
        </Box>
        <Box pb={4} px={[0, 3]}>
          <Form
            onSubmit={values => onSubmitExpressDeal({ ...values, gaCategory })}
            promoDeal
            flightTypes={[
              FLIGHT_TYPE_INFO[ROUND_TRIP],
              FLIGHT_TYPE_INFO[ONE_WAY]
            ]}
          />
        </Box>
      </Box>
    </Modal>
  )
}
